import { BREAKPOINTS } from '../utils/constants';
import scrollIntoViewWithOffset from '../utils/scrollIntoViewWithOffset';

const initProductStickyAtc = () => {
  const stickyAtc = document.querySelector('[data-sticky-atc-wrapper]');
  if (!stickyAtc) return;

  const header = document.querySelector('header.shopify-section-group-header-group');
  const desktopMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);
  const variantInputEls = document.querySelectorAll('[data-variant-input]');
  const sellingPlanInputEls = document.querySelectorAll('[data-selling-plan-radio]');
  const stickyAtcButton = stickyAtc.querySelector('[data-sticky-atc-btn]');
  const selectEls = stickyAtc.querySelectorAll('[data-product-sticky-atc-select]');
  const form = document.querySelector('[data-product-main] form');
  const mainAtcButton = form?.querySelector('button[type="submit"]');
  const headerAnchorEl = document.querySelector('[data-header-container]');
  const stickySectionContainer = stickyAtc.querySelector('[sticky-section-container]');
  const stickySections = document.querySelectorAll('[data-show-in-atc-bar]');
  const stickySectionButtons = [];

  const selectSection = (button) => {
    stickySectionButtons.forEach(other => other.removeAttribute('selected'));
    button.setAttribute('selected', 'selected');
    scrollIntoViewWithOffset(`#${button.dataset.target}`, stickyAtc.offsetHeight + header.offsetHeight);
  };

  const buildLinks = () => {
    if (stickySections.length) {
      stickySections.forEach((section) => {
        const stickyButton = document.createElement('button');
        stickyButton.classList.add('sticky-atc-section');
        stickyButton.textContent = section.dataset.showInAtcBar;
        stickyButton.dataset.target = section.closest('section').id;
        stickySectionContainer.appendChild(stickyButton);
        stickySectionButtons.push(stickyButton);

        stickyButton.addEventListener('click', (e) => {
          selectSection(stickyButton);
        });
      });
    }
  };

  const syncButtons = () => {
    for (const name of stickyAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.removeAttribute(name);
      }
    }
    for (const name of mainAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.setAttribute(name, mainAtcButton.getAttribute(name));
      }
    }
    stickyAtcButton.innerHTML = mainAtcButton.innerHTML;
  };

  if (mainAtcButton) {
    const mainAtcBtnObserver = new MutationObserver(syncButtons);
    syncButtons();
    buildLinks();
    mainAtcBtnObserver.observe(mainAtcButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Show sticky once the main ATC scrolls past the header (or past the top of the viewport, when the
  // header isn't sticky - e.g. the product page default); hide as soon as it lines up again
  if (mainAtcButton && headerAnchorEl) {
    const handleScroll = () => {
      const headerIsSticky = header && getComputedStyle(header).position === 'sticky';
      const anchorBottom = headerIsSticky ? headerAnchorEl.getBoundingClientRect().bottom : 0;
      const atcBottom = mainAtcButton.getBoundingClientRect().bottom;
      const showSticky = atcBottom <= anchorBottom;

      stickyAtc.classList.toggle('hidden', !showSticky);
      stickyAtc.toggleAttribute('data-sticky-atc-open', showSticky);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
  }

  stickyAtcButton.addEventListener('click', () => {
    if (!mainAtcButton || !form) return;
    if (desktopMediaQuery.matches) {
      mainAtcButton.click();
    } else {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (!variantInputEls.length && !sellingPlanInputEls.length) return;

  const allInputEls = [...variantInputEls, ...sellingPlanInputEls];

  const updateStickySelect = variantInput => {
    if (variantInput.type === 'radio' && variantInput.checked !== true) return;
    selectEls.forEach(select => {
      if (select.name === variantInput.name) {
        select.value = variantInput.value;
      }
    });
  };

  const updateStickyAtcVariant = event => {
    const { target } = event;
    if (target.tagName === 'SELECT' && [...selectEls].includes(target)) {
      allInputEls.forEach(inputEl => {
        if (inputEl.tagName === 'SELECT' && inputEl.name === target.name) {
          inputEl.value = target.value;
          inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (inputEl.type === 'radio' && inputEl.name === target.name && inputEl.value === target.value) {
          inputEl.checked = true;
          inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      return;
    }
    if (target.type === 'radio') {
      allInputEls.forEach(inputEl => {
        if (inputEl.value === target.value && target.name === inputEl.name) {
          if (inputEl.type === 'radio') {
            inputEl.checked = true;
          } else if (inputEl.tagName === 'SELECT') {
            inputEl.value = target.value;
          }
          inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  };

  allInputEls.forEach(inputEl => {
    updateStickySelect(inputEl);

    inputEl.addEventListener('change', () => {
      updateStickySelect(inputEl);
    });
  });
  selectEls.forEach(select => select.addEventListener('change', updateStickyAtcVariant));
};

export default initProductStickyAtc;
